import React from "react";
import "./Blog.css";

const Blog = () => {
  return (
    <div className="blog-page">
      <div
        className="blog-coming-soon-banner"
        role="status"
        aria-live="polite"
      >
        <div className="blog-coming-soon-overlay" aria-hidden="true" />
        <span className="blog-coming-soon-text">Coming Soon</span>
      </div>
    </div>
  );
};

export default Blog;
